module.exports = __webpack_public_path__ + "static/media/popular_learning_topics_1.0be5ec1e.png";